import React, { useState, useRef, useEffect } from 'react';
import './CuratedEventsSection.css';

const CuratedEventsSection = ({ isLoggedOut = false }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // REAL CLUB & SMALL CONCERT DATA - Curated selection
  const realCuratedData = [
    {
      id: 'ra_curated_1',
      artist: '🔥 DJ K-Pulse',
      title: '🔥 House Night @ Cakeshop',
      date: '2025.10.14 @24:00',
      location: 'Cakeshop, Busan',
      likes: 547,
      rating: '9/10',
      image: 'https://images.unsplash.com/photo-1571266028243-e68f96da73f3?w=300&h=200&fit=crop&crop=center'
    },
    {
      id: 'ra_curated_2',
      artist: 'Electric Pulse',
      title: 'Trance Night @ Club Mass',
      date: '2025.11.02 @22:00',
      location: 'Club Mass, Daegu',
      likes: 356,
      rating: '9/10',
      image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a5d4?w=300&h=200&fit=crop&crop=center'
    },
    {
      id: 'ra_curated_3',
      artist: 'Ambient Seoul',
      title: 'Korean Techno @ Club Ellui',
      date: '2025.10.07 @24:00',
      location: 'Club Ellui, Seoul',
      likes: 210,
      rating: '9/10',
      image: 'https://picsum.photos/300/200?random=205'
    },
    {
      id: 'ra_curated_4',
      artist: 'House Seoul',
      title: 'Korean House @ Faust',
      date: '2025.10.04 @23:00',
      location: 'Faust, Seoul',
      likes: 233,
      rating: '9/10',
      image: 'https://picsum.photos/300/200?random=208'
    },
    {
      id: 'ra_curated_5',
      artist: 'Deep House Seoul',
      title: 'Minimal Night @ Cakeshop',
      date: '2025.11.06 @22:00',
      location: 'Cakeshop, Incheon',
      likes: 469,
      rating: '8/10',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=200&fit=crop&crop=center'
    },
    {
      id: 'ra_curated_6',
      artist: 'Neon Pulse',
      title: 'Techno Night @ Club Answer',
      date: '2025.11.06 @22:00',
      location: 'Club Answer, Seoul',
      likes: 93,
      rating: '8/10',
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=200&fit=crop&crop=center'
    }
  ];

  // Load curated events - now using direct data injection
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Use real club & small concert data directly
        console.log('🎵 Setting real curated club data:', realCuratedData);
        setEvents(realCuratedData);
        
      } catch (err) {
        console.error('Error loading curated events:', err);
        setError('Failed to load events');
        // Fallback to mock data
        setEvents([
          {
            id: 1,
            artist: 'Alex',
            title: 'Neon Dreams',
            date: '9.25 Thu @8pm',
            location: 'Cakeshop, Hongdae',
            likes: 42,
            rating: '9/10',
            image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=200&fit=crop'
          },
          {
            id: 2,
            artist: 'Maya',
            title: 'Electric Pulse',
            date: '9.26 Fri @9pm',
            location: 'UNDERCITY, Gangnam',
            likes: 38,
            rating: '9/10',
            image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=200&fit=crop'
          },
          {
            id: 3,
            artist: 'DJ Luna',
            title: 'Midnight Vibes',
            date: '9.27 Sat @10pm',
            location: 'vurt., Itaewon',
            likes: 51,
            rating: '10/10',
            image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=300&h=200&fit=crop'
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const carouselRef = useRef(null);
  const itemsPerView = 3;

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex + itemsPerView >= events.length ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? Math.max(0, events.length - itemsPerView) : prevIndex - 1
    );
  };

  // Drag functionality
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(currentIndex);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    const newIndex = Math.max(0, Math.min(events.length - itemsPerView, scrollLeft - walk / 100));
    setCurrentIndex(Math.round(newIndex));
  };

  // Touch events for mobile
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - carouselRef.current.offsetLeft);
    setScrollLeft(currentIndex);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.touches[0].pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    const newIndex = Math.max(0, Math.min(events.length - itemsPerView, scrollLeft - walk / 100));
    setCurrentIndex(Math.round(newIndex));
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  // Show loading state
  if (loading) {
    return (
      <section className="curated-events">
        <div className="container">
          <div className="section-header">
            <h2>{isLoggedOut ? 'Popular Events' : 'Curated Events for You'}</h2>
          </div>
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p>Loading curated events...</p>
          </div>
        </div>
      </section>
    );
  }

  // Show error state
  if (error) {
    return (
      <section className="curated-events">
        <div className="container">
          <div className="section-header">
            <h2>{isLoggedOut ? 'Popular Events' : 'Curated Events for You'}</h2>
          </div>
          <div className="error-state">
            <p>{error}</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="curated-events">
      <div className="container">
        <div className="section-header">
          <h2>{isLoggedOut ? 'Popular Events' : 'Curated Events for You'}</h2>
        </div>
        
        <div className="carousel-container">
          <button className="carousel-btn prev-btn" onClick={prevSlide}>
            <i className="fas fa-chevron-left"></i>
          </button>
          
          <div 
            className="events-carousel"
            ref={carouselRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
          >
            <div className="carousel-track" style={{ transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)` }}>
              {console.log('🎵 Rendering curated events:', events)}
              {events.map((event) => (
                <div key={event.id} className="event-card">
                  <div className="event-image">
                    <img src={event.image} alt={event.title} />
                  </div>
                  <div className="event-info">
                    <h3 className="artist-name">{event.artist}</h3>
                    <h4 className="event-title">{event.title}</h4>
                    <div className="event-details">
                      <div className="event-detail">
                        <i className="fas fa-clock"></i>
                        <span>{event.date}</span>
                      </div>
                      <div className="event-detail">
                        <i className="fas fa-map-marker-alt"></i>
                        <span>{event.location}</span>
                      </div>
                      <div className="event-detail">
                        <i className="fas fa-heart"></i>
                        <span>{event.likes}</span>
                      </div>
                      <div className="event-detail">
                        <i className="fas fa-star"></i>
                        <span>{event.rating}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <button className="carousel-btn next-btn" onClick={nextSlide}>
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
        
        <div className="carousel-indicators">
          {Array.from({ length: Math.ceil(events.length / itemsPerView) }).map((_, index) => (
            <button
              key={index}
              className={`indicator ${Math.floor(currentIndex / itemsPerView) === index ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index * itemsPerView)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CuratedEventsSection;
